/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class MaterialTransformer extends Transformer {

  static fetch(material) {
    return {
      id: material.id,
      organizationId: material.organization_id,
      materialTypeId: material.material_type_id,
      materialType: material.material_type,
      unitMeasureId: material.unit_measure_id,
      unitMeasure: material.unit_measure,
      supplierId: material.supplier_id,
      name: material.name,
      description: material.description,
      isActive: material.is_active,
      minimumStockLevel: material.minimum_stock_level,
    };
  }

  static send(material) {
    return {
      id: material.id,
      organization_id: material.organizationId,
      material_type_id: material.materialTypeId,
      unit_measure_id: material.unitMeasureId,
      supplier_id: material.supplierId,
      name: material.name,
      description: material.description,
      is_active: material.isActive,
      minimum_stock_level: material.minimumStockLevel,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/material.js